module.exports = __webpack_public_path__ + "static/img/salon_du_cinematographe.e15acd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/salon_du_cinematographe.jpg
// module id = 37
// module chunks = 0